import { use } from 'react';
import { PaymentsContext } from './PaymentsContext';

export function usePayments() {
  const ctx = use(PaymentsContext);
  if (!ctx) throw new Error('usePayments must be used within PaymentsProvider');
  return ctx;
}
